import { useFormContext, useFormState, useWatch } from "react-hook-form";

import { RenderElement } from "@up/form";

import { StudentAddressCountryName } from "./student-address-country";

export const StudentAddressStateName = "student-mailing-address-state";

export function StudentAddressState({
  label = "Student State of Residence",
}: {
  label?: string;
}) {
  const { control, register } = useFormContext();
  const { errors } = useFormState();
  const formValues = useWatch();

  return (
    <RenderElement
      control={control}
      element={{
        _id: StudentAddressStateName,
        type: "stateselect",
        name: StudentAddressStateName,
        label: label,
        validate: {
          presence: true,
        },
        dependent: {
          dependentName: StudentAddressCountryName,
          condition: "equal",
          conditionValue: "United States",
        },
      }}
      errors={errors}
      formValues={formValues}
      register={register}
    />
  );
}
